import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';
import { Col, Row } from 'antd';
import CompanySkeleton from './CompanySkeleton';
import SliderCircledBackIcon from '../assets/svgIcons/SliderCircledBackIcon';
import SliderCircledForwardIcon from '../assets/svgIcons/SliderCircledForwardIcon';
import CustomSlider from '../components/CustomSlider';
import { maxMobile, smMobile } from '../../../Utils/utilsStyle';
const Wrapper = styled.div`
.right-side {
  display: flex;
  justify-content: end;
  .skeleton-box {
    @media all and (max-width: ${smMobile}) {
      width: 60px;
      min-width: 60px;
      height: 35px !important;
    }
  }
}
  .companies-section { 
    .company-card-wrapper {
      width: 200px !important;
      @media all and (max-width: ${maxMobile}){
        width: 150px !important;
      }
    }
    .company-skeleton {
      .skeleton-box {
        &.btn {
          display: none;
        }
      }
    }  
  }
`;
const ClusterDetailPageSkeleton = function ClusterDetailPageSkeleton() {
  const getSlidesToShow = () => {
    if (window.innerWidth <= 575) return 2;
    if (window.innerWidth <= 768) return 3;
    if (window.innerWidth <= 1024) return 4;
    if (window.innerWidth <= 1440) return 5;
    return 6;
  }
  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());
  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getSlidesToShow());
    };

    window.addEventListener('resize', handleResize);
  }, []);
  return (
    <Wrapper className='cluster-skeleton'>
      <div className='container'>
        <div className="fancy-box">
          <div className="header-section">
            <div className="left-side">
              <SkeletonCustom width="200px" height="30px" />
            </div>
            <div className="right-side">
              <SkeletonCustom width="90px" height="40px" />
              <SkeletonCustom width="90px" height="40px" />
              <SkeletonCustom width="90px" height="40px" />
              <SkeletonCustom width="90px" height="40px" />
            </div>
          </div>
          <div className="companies-section">
            <CustomSlider
              slidesToShow={slidesToShow}
              totalItems={slidesToShow}
              NextArrow={SliderCircledForwardIcon}
              PrevArrow={SliderCircledBackIcon}
            >
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <div
                  key={item}
                  className="company-card-wrapper"
                >
                  <CompanySkeleton />
                </div>
              ))}
            </CustomSlider>

          </div>

        </div>

      </div>
    </Wrapper>
  )
}
export default ClusterDetailPageSkeleton;
